module.exports = __webpack_public_path__ + "img/Synelva_120X35.4b191c7e.png";